import { Input, InputProps, forwardRef } from '@chakra-ui/react'

interface ITextInputProps extends InputProps {
  isDisabled?: boolean
}

const TextInput = forwardRef((props: ITextInputProps, ref) => {
  const { isDisabled = false, ...rest } = props

  return (
    <Input
      _hover={{ borderColor: 'secondary.400' }}
      borderRadius='0'
      type='text'
      ref={ref}
      {...rest}
    />
  )
})

export { TextInput }
